import { render, staticRenderFns } from "./PersonCenterSubFunctions.vue?vue&type=template&id=c5934656"
import script from "./PersonCenterSubFunctions.vue?vue&type=script&lang=js"
export * from "./PersonCenterSubFunctions.vue?vue&type=script&lang=js"
import style0 from "./PersonCenterSubFunctions.vue?vue&type=style&index=0&id=c5934656&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports